import { render, staticRenderFns } from "./m_electronicInvoice.vue?vue&type=template&id=4f0e1c71&scoped=true"
import script from "./m_electronicInvoice.vue?vue&type=script&lang=js"
export * from "./m_electronicInvoice.vue?vue&type=script&lang=js"
import style0 from "./m_electronicInvoice.vue?vue&type=style&index=0&id=4f0e1c71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e1c71",
  null
  
)

export default component.exports